import api from "../api/axios";

export const getDepartmentById = async (company_id) => {
  try {
    const response = await api.get(`department/${company_id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching department:", error);
    throw error;
  }
};

export const getDepartmentDetails = async (department_id) => {
  try {
    const response = await api.get(`department/details/${department_id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching department details:", error);
    throw error;
  }
};
